import React from 'react'
import './styles.css'
import Slider from 'rc-slider'

const NewSquareHandle = (props) => {
    const handleStyle = {
        ...props.props.style,
        position: "absolute",
        height: 50,
        width: 8,
        border: "1px solid black",
        backgroundColor: "white",
        cursor: "pointer",
        transform: 'translate(-50%, -50%)',
        zIndex: 2
    }

    const value = props.props["aria-valuenow"];

    return (
        <div style={handleStyle}>
            <div style={{ position: "absolute", left: "50%", transform: "translate(-50%, -125%)", background: "white", padding: "0px 10px" }}>New</div>
            <div style={{ position: "absolute", left: "50%", transform: "translate(-50%, 250%", background: "white", padding: "0px 5px" }}>{value}</div>
        </div>
    )
}

const CurrentSquareHandle = (props) => {
    const handleStyle = {
        ...props.props.style,
        position: "absolute",
        height: 50,
        width: 8,
        border: "1px solid black",
        backgroundColor: "black",
        transform: 'translate(-50%, -50%)',
        zIndex: 2
    }
    
    const value = props.props["aria-valuenow"];

    return (
        <div style={handleStyle}>
            <div style={{ position: "absolute", left: "50%", transform: "translate(-50%, -125%)" }}>Current</div>
            <div style={{ position: "absolute", left: "50%", transform: "translate(-50%, 250%" }}>{value}</div>
        </div>
    )
}

const DoubleSlider = ({ min, max, currentValue, value, onChange, step = 1, labelEndText, horizontalLabel }) => {
    const containerStyle = {
        position: "absolute",
        height: "0px",
        padding: "0px",
    }

    const newSliderStyle = {
        track: {
            backgroundColor: "black",
            height: "1px",
            borderRadius: "0"
        },
        rail: {
            backgroundColor: "black",
            height: "1px",
            borderRadius: "0"
        }
    }

    return (
        <div style={{ position: "relative", height: "150px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <div style={{ position: "relative", display: "flex", alignItems: "center", borderLeft: "2px solid black", borderRight: "2px solid black", height: "20px", width: "100%" }}>
                
                {/* Sliders */}
                <Slider min={min} max={max} step={step} value={currentValue} style={containerStyle} styles={newSliderStyle} handleRender={CurrentSquareHandle} />
                <Slider min={min} max={max} step={step} value={value} onChange={onChange} style={containerStyle} styles={newSliderStyle} handleRender={NewSquareHandle} />

                {/* Labels */}  
                <div style={{ position: "absolute", bottom: "0", transform: "translate(-50%, 100%) " }}>{`${min} ${labelEndText}`}</div>
                <div style={{ position: "absolute", bottom: "0", right: "0", transform: "translate(50%, 100%)" }}>{`${max} ${labelEndText}`}</div>
            </div>
            <div style={{ position: "absolute", bottom: "0px" }}>{horizontalLabel}</div>
        </div>
    )
}

export default DoubleSlider